import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import _ from "lodash";
import "./style.css";
import "../style.css";
import "../../../common/style.css";
import {
  ColumnResizedEvent,
  FilterChangedEvent,
  FilterModifiedEvent,
  GridApi,
} from "ag-grid-community";
import "ag-grid-enterprise";
import Customtooltip from "../../../components/CustomTooltip/index";
import { onGridSizeChanged } from "../../../components/AgGrid/grid-util";
import { constants } from "../../../common/constants";
import { LoanRecallsColDefs } from "../../../common/columnLoanRecalls";
import { hasAccess } from "../../../common/commonFunctions";
import { pageConstant } from "../../../config/pageConstant";

interface AgGridProps {
  title?: string;
  rowData: any;
  height?: any;
  onClickHan?: any;
  onClickSelectData?: any;
  onCellChange?: any;
  seTtotalSelectedRows?: any;
  getBtnRef?: any;
  getGridApi?: any;
  doesExternalFilterPass?: any;
  isExternalFilterPresent?: any;
  isDeselectAll?: boolean;
  getContextMenuItems?: any;
  globalSearch?: any;
  isSingleRowInserted?: boolean;
  defaultFilter?: any;
  appliedFilterStateLoanGrid?: any;
  filters?: any;
  onRowSelected: any;
  applyLoanMetricFilters: any;
  isResetFilters: boolean;
  recallCount?: any;
  terminateCount?: any;
  openCount?: any;
  pastDueCount?: any;
  past30dayDueCount?: any;
  partialReturnCount?: any;
  fullReturnCount?: any;
  nonOutstandingCount?: any;
  setSelectedRows?: any;
  onRecall?: any;
  fullRecallCount?: any;
  insertRowId?: any[];
}

const LoanRecallsGrid = ({
  title,
  rowData,
  onCellChange,
  getBtnRef,
  getGridApi,
  doesExternalFilterPass,
  isExternalFilterPresent,
  isDeselectAll,
  getContextMenuItems,
  globalSearch,
  isSingleRowInserted,
  defaultFilter,
  appliedFilterStateLoanGrid,
  filters,
  onRowSelected,
  applyLoanMetricFilters,
  isResetFilters,
  recallCount,
  terminateCount,
  openCount,
  pastDueCount,
  past30dayDueCount,
  partialReturnCount,
  fullReturnCount,
  nonOutstandingCount,
  setSelectedRows,
  onRecall,
  fullRecallCount,
  insertRowId,
}: // onBtExport,
AgGridProps) => {
  const gridRef = useRef<any>(null);
  const [columnDefs] = useState<any>([...LoanRecallsColDefs]);
  const [isRecallFilterActive, setIsRecallFilterActive] = useState(false);
  const [isTerminationFilterActive, setIsTerminationFilterActive] =
    useState(false);
  const [isOpenFilterActive, setIsOpenFilterActive] = useState(false);
  const [isPastDueFilterActive, setIsPastDueFilterActive] = useState(false);
  const [isPast30dayDueFilterActive, setIsPast30dayDueFilterActive] =
    useState(false);
  const [isPartialReturnFilterActive, setIsPartialReturnFilterActive] =
    useState(false);
  const [isFullReturnFilterActive, setIsFullReturnFilterActive] =
    useState(false);
  const [isNonOutstandingFilterActive, setIsNonOutstandingFilterActive] =
    useState(false);
  const [selectedGridRows, setSelectedGridRows] = useState<any>([]);
  const [isFullRecallFilterActive, setIsFullRecallFilterActive] =
    useState(false);
  const [currentRowId, setCurrentRowId] = useState(null);
  const [flashedRowIds, setFlashedRowIds] = useState<any>([]);
  // const [currentRowTicker, setCurrentRowTicker] = useState(null)

  let gridApi: any;
  const defaultColDef = useMemo<any>(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      floatingFilter: false,
      suppressFilterButton: false,
      editable: true,
      resizable: true,
      headerCheckboxSelectionFilteredOnly: true,
      tooltipComponent: Customtooltip,
      menuTabs: [constants.FilterMenuTab],
      tooltipShowDelay: 10,
      tooltipMouseTrack: true,
      suppressKeyboardEvent: (params: any) => {
        let isTabKey = params?.event?.key === constants.Tab;
        if (isTabKey) gridRef?.current?.api?.stopEditing();
        return false;
      },
    };
  }, []);

  useEffect(() => {
    let refreshParams: any = {
      force: true,
      suppressFlash: true,
    };
    gridRef?.current!.api?.refreshCells(refreshParams);
  }, [globalSearch]);

  useEffect(() => {
    setTimeout(() => {
      filterMetricRows();
    }, 800);
  }, [
    isRecallFilterActive,
    isTerminationFilterActive,
    isOpenFilterActive,
    isPastDueFilterActive,
    isPast30dayDueFilterActive,
    isPartialReturnFilterActive,
    isFullReturnFilterActive,
    isNonOutstandingFilterActive,
    isFullRecallFilterActive,
  ]);

  const filterMetricRows = () => {
    let filters = {
      isRecallFilterActive: isRecallFilterActive,
      isTerminationFilterActive: isTerminationFilterActive,
      isOpenFilterActive: isOpenFilterActive,
      isPastDueFilterActive: isPastDueFilterActive,
      isPast30dayDueFilterActive: isPast30dayDueFilterActive,
      isPartialReturnFilterActive: isPartialReturnFilterActive,
      isFullReturnFilterActive: isFullReturnFilterActive,
      isNonOutstandingFilterActive: isNonOutstandingFilterActive,
      isFullRecallFilterActive: isFullRecallFilterActive,
    };
    applyLoanMetricFilters?.(filters);
  };

  useEffect(() => {
    gridApi = gridRef.current!.api;
    var gridColumnApi = gridRef.current!.columnApi;
    getUpdatedData(rowData);
    getBtnRef(gridRef);
    getName(gridApi, gridColumnApi);
  }, [rowData]);

  const onColumnResized = useCallback((params: ColumnResizedEvent) => {}, []);

  // const getUpdatedData = useCallback(
  //   async (data: any) => {
  //     await gridApi?.applyTransactionAsync({ update: [rowData] });
  //     if (gridRef && gridRef?.current && gridRef?.current!.api) {
  //       // if(insertRowId && insertRowId?.length>0){
  //       //   const rowNodes:any[]=[]
  //       //   insertRowId?.forEach((id:any, index:number)=>{
  //       //      const rowNode = gridRef?.current?.api?.getRowNode(id);
  //       //     if (rowNode && !_.includes(flashedRowIds, id)) {
  //       //       rowNodes.push(rowNode)
  //       //     }else{
  //       //       const rowNode = gridRef?.current?.api?.getDisplayedRowAtIndex(index);
  //       //       if(rowNode)rowNodes.push(rowNode)
  //       //     }
  //       //   })
  //       //   setFlashedRowIds((previousIds: any) => [insertRowId, ...previousIds]);
  //       //   gridApi?.flashCells({ rowNodes: rowNodes });
  //       // }
  //       gridRef.current!.api.refreshCells();
  //     }
  //   },
  //   [rowData]
  // );
const getUpdatedData = useCallback(
  async (data: any) => {
    if (!gridRef.current || !gridRef.current.api) return;

    const uniqueData = _.uniqBy(data, (item: any) => item.recallId>0? item.recallId: item.contract_id);

    await gridApi?.applyTransactionAsync({ update: uniqueData });

    gridRef.current.api.refreshCells();

    // Optional: flash newly inserted rows
    // if (insertRowId && insertRowId.length > 0) {
    //   const rowNodes: any[] = [];
    //   insertRowId.forEach((id: any) => {
    //     const rowNode = gridRef.current?.api?.getRowNode(id);
    //     if (rowNode && !_.includes(flashedRowIds, id)) {
    //       rowNodes.push(rowNode);
    //     }
    //   });
    //   setFlashedRowIds((prev: any) => [insertRowId, ...prev]);
    //   gridApi?.flashCells({ rowNodes });
    // }
  },
  [rowData, flashedRowIds]
);

  useEffect(() => {
    if (defaultFilter && gridRef) {
      const filterComponent = gridRef?.current?.api?.getFilterInstance(
        defaultFilter.column
      );
      if (filterComponent) {
        filterComponent?.setModel({ values: defaultFilter.values });
        gridApi.onFilterChanged();
      }
    }
  }, [gridRef]);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
    gridApi = params.api;

    var gridColumnApi = params.columnApi;
    // Emmits the gridApi refrence to the parent component
    if (getGridApi) {
      getGridApi(gridApi, gridColumnApi);
    }
  };

  /**
   * Executes whenever Grid/Table filter modifies - this is more sensitive
   * @param params
   */
  const onFilterModified = (params: FilterModifiedEvent) => {
    const { api, columnApi } = params;
  };

  /**
   * Executes whenever Grid/Table filter changes
   * @param params
   */
  const onFilterChanged = (params: FilterChangedEvent) => {
    const { api, columnApi } = params;
    appliedFilterStateLoanGrid(api?.getFilterModel());
    getName(api, columnApi);
  };

  const onFirstDataRendered = () => {
    let gridColumnApi = gridRef?.current!.columnApi;
    let gridRefApi = gridRef?.current!.api;
    getName(gridRefApi, gridColumnApi);
  };

  /**
   * To skip pinned rows on the basis of Page path
   * @returns shouldSkip : boolean
   */
  const skipPinnedRow = (): boolean => {
    return false;
  };

  const getName = (api: any, columnApi: any) => {
    if (!api || !columnApi || skipPinnedRow()) return;
    let rows: any = {};
    var result = [];
    columnApi?.getAllGridColumns().forEach((item: any) => {
      rows[item.colId] = null;
    });
    let columnsWithAggregation = [
      "quantity",
      "return_qty",
      "sod_loan_qty",
      "loan_qty",
    ];
    columnsWithAggregation.forEach((element) => {
      api?.forEachNodeAfterFilter((rowNode: any) => {
        if (rowNode && rowNode.data && rowNode.data[element]) {
          rows[element] += Number(parseFloat(rowNode.data[element]));
        }
      });
    });
    // let contractIdTotal = ["contract_id"];
    // let countContractId_ = 0;
    // contractIdTotal.forEach((element) => {
    //   api?.forEachNodeAfterFilter((rowNode: any) => {
    //     countContractId_++;
    //     if (rowNode && rowNode.data && rowNode.data[element]) {
    //       rows[element] += Number(parseFloat(rowNode.data[element]));
    //     }
    //   });
    // });
    // rows["contract_id"] = countContractId_;
    var count = Number(2);
    for (var i = 0; i < count; i++) {
      if (i === 0) {
        result.push({
          isTotalRow: true,
          contract_id: "Total Contracts",
          cpty_id: "Total CPTY",
          ticker: "Total Symbol",
          quantity: "Total Recall Qty",
          return_qty: "Total Return Qty",
          sod_loan_qty: "Total SOD Loan Qty",
          loan_qty: "Loan Qty",
        });
      } else {
        rows["isTotalRow"] = true;
        rows["ticker"] = countUnique("ticker", api);
        rows["cpty_id"] = countUnique("cpty_id", api);
        rows["contract_id"] = countUnique("contract_id", api);
        result.push(rows);
      }
    }
    api?.setPinnedBottomRowData(result);
  };

  /**
   * Method counts the unique value for given attribute (for filtered values also)
   * @param attribute
   * @returns unique values count
   */
  const countUnique = (attribute: string, api: GridApi): number => {
    const uniqueItemsSet: Set<any> = new Set();
    api?.forEachNodeAfterFilter((rowNode: any) => {
      if (rowNode?.data instanceof Object && attribute in rowNode.data) {
        uniqueItemsSet.add(rowNode.data[attribute]);
      }
    });
    return uniqueItemsSet.size;
  };

  useEffect(() => {
    let gridRefApi = gridRef?.current!.api;
    gridRefApi?.setFilterModel?.(null);
    setIsRecallFilterActive(false);
    setIsTerminationFilterActive(false);
    setIsOpenFilterActive(false);
    setIsPastDueFilterActive(false);
    setIsPast30dayDueFilterActive(false);
    setIsPartialReturnFilterActive(false);
    setIsFullReturnFilterActive(false);
    setIsNonOutstandingFilterActive(false);
    setIsFullRecallFilterActive(false);
    gridRefApi?.deselectAll?.();
    gridRef.current?.api?.deselectAll();
    setSelectedGridRows([]);
  }, [isResetFilters]);

  useEffect(() => {
    if (isDeselectAll !== undefined) {
      gridRef.current?.api?.deselectAll();
      setSelectedGridRows([]);
    }
  }, [isDeselectAll]);

  const rowClassRules = useMemo(() => {
    return {
      "is-new-warning": (params: any) => {
        var isNew = params && params.data && params.data.is_new;
        return isNew === "TRUE";
      },
      "is-new-recall": (params: any) => {
        var isNew = params && params.data && params.data.is_Recall;
        return isNew === "True";
      },
    };
  }, []);

  const onSelectionChanged = (params: any) => {
    const selectedRows = gridRef.current!.api.getSelectedRows();
    if (
      params?.source === "uiSelectAllFiltered" &&
      params?.type === "selectionChanged"
    ) {
      if (selectedRows?.length > 0) {
        const groupedContracts = _.groupBy([...selectedRows], "contract_id");
        let list: any = [];
        _.forOwn(groupedContracts, function (value, key) {
          
        let totalRecalledQty = 0;
        if(value?.length === 1 && value[0]?.isRecall === "N" && value[0]?.loanet_status === "Rejected"){
            totalRecalledQty = totalRecalledQty+0
        } else{
          const recalledLoans = value?.filter((r: any)=> r?.isRecall === "Y")
          if(recalledLoans && recalledLoans?.length>0)
            totalRecalledQty = _.sumBy(recalledLoans, "quantity");
        }
        

          let contract = value[0];
          if (contract?.sod_quantity === 0 && contract?.loan_qty > 0 ? contract?.loan_qty > totalRecalledQty : contract?.sod_quantity > totalRecalledQty) {
            contract.recalled_quantity = totalRecalledQty;
            list.push(contract);
          }
        });
        setSelectedGridRows(list);
      } else {
        setSelectedGridRows([]);
      }
    } else if (selectedRows?.length === 0) {
      setSelectedGridRows([]);
    }
  };

  const onGridRowSelected = (params: any) => {
    if (params?.source !== "uiSelectAllFiltered") {
      let contracts: any[] = [];
      let selected: any[] = [];
      if (params?.node?.selected) {
        contracts = rowData?.filter(
          (x: any) => x.contract_id === params?.data?.contract_id
        );

        let totalRecalledQty = 0
        contracts?.forEach((r: any) => {
          if (r.isRecall === "Y") {
            totalRecalledQty = totalRecalledQty + r.quantity;
          }
        })

        if (!params?.data?.isFullyRecalled) {
          const updatedRows = contracts.map((r: any) => {
            return { ...r, recalled_quantity: totalRecalledQty };
          });

          selected = _.uniqBy([...updatedRows], "contract_id");

          setSelectedGridRows((previousRows: any) => {
            if (_.isArray(previousRows)) {
              return _.concat(previousRows, selected);
            }
            return previousRows;
          });

          contracts?.forEach((r: any) => {
            params?.api
              ?.getRowNode(r?.id)
              .setSelected(true);
          });
        }
      } else {
        contracts = rowData?.filter(
          (x: any) => x.contract_id === params?.data?.contract_id
        );
        const updatedRows = _.pullAllBy(selectedGridRows, contracts, "id");
        selected = [...updatedRows];
        setSelectedGridRows(selected);
        contracts?.forEach((r: any) => {
          params?.api
            ?.getRowNode(r?.id)
            .setSelected(false);
        });
      }
    }
  };

  useEffect(() => {
    const uniqueRecords = _.uniqBy(selectedGridRows, "contract_id");
    setSelectedRows(uniqueRecords);
  }, [selectedGridRows]);

  const onCellValueChanged = useCallback((event: any) => {
    let updateArray: any = [];
    event.value = event.value.toUpperCase();
    onCellChange(event.data, event.value, event.column);
    updateArray.push(event.data);

    gridApi = gridRef.current!.api;
    var gridColumnApi = gridRef.current!.columnApi;
    gridApi?.applyTransaction({ update: updateArray });
    var params = {
      force: true,
      suppressFlash: true,
      columns: [event.column],
    };
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 100,
      maxWidth: 200,
    };
  }, []);

  const getRowId = useMemo(() => {
     return (params: any) => params.data?.id;
      // return (params: any) => params.data?.recallId>0? params.data?.recallId: (params.data?.contract_id? params.data?.contract_id:params.data?.id);

    // return (params: any) =>
    //   params.data?.recallId
    //     ? params.data?.recallId
    //     : params.data?.contract_id
    //     ? params.data?.contract_id
    //     : "";
  }, []);

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressColumnFilter: false,
            suppressColumnSelectAll: false,
            suppressColumnExpandAll: true,
          },
        },
      ],
      defaultToolPanel: "",
    };
  }, []);

  const onGridRowDataChanged = (params: any) => {
    let refreshParams: any = {
      force: true,
      suppressFlash: true,
    };
    gridRef.current!.api.refreshCells(refreshParams);
    setTimeout(() => {
      if (gridRef && gridRef?.current && gridRef?.current!.api) {
        if (filters) {
          if (gridApi?.getFilterModel() !== filters)
            gridApi?.setFilterModel(filters);
        }
      }
    }, 500);
  };

  const onRecallFilter = (isRecallSelected: boolean = false) => {
    if (isRecallSelected) {
      if (!isRecallFilterActive && isTerminationFilterActive) {
        setIsTerminationFilterActive(false);
      }
      setIsRecallFilterActive(!isRecallFilterActive);
    } else {
      if (!isTerminationFilterActive && isRecallFilterActive) {
        setIsRecallFilterActive(false);
      }
      setIsTerminationFilterActive(!isTerminationFilterActive);
    }
  };

  const onPastDueFilter = (isPastDue: boolean = false) => {
    if (isPastDue) {
      if (!isPastDueFilterActive && isPast30dayDueFilterActive) {
        setIsPast30dayDueFilterActive(false);
      }
      setIsPastDueFilterActive(!isPastDueFilterActive);
    } else {
      if (!isPast30dayDueFilterActive && isPastDueFilterActive) {
        setIsPastDueFilterActive(false);
      }
      setIsPast30dayDueFilterActive(!isPast30dayDueFilterActive);
    }
  };

  const onPartialReturnFilter = (isPartialReturn: boolean = false) => {
    if (isPartialReturn) {
      if (!isPartialReturnFilterActive && isFullReturnFilterActive) {
        setIsFullReturnFilterActive(false);
      }
      setIsPartialReturnFilterActive(!isPartialReturnFilterActive);
    } else {
      if (!isFullReturnFilterActive && isPartialReturnFilterActive) {
        setIsPartialReturnFilterActive(false);
      }
      setIsFullReturnFilterActive(!isFullReturnFilterActive);
    }
  };

  const onOpenFilter = () => {
    setIsOpenFilterActive(!isOpenFilterActive);
  };

  const onNonOutstandingFilter = () => {
    setIsNonOutstandingFilterActive(!isNonOutstandingFilterActive);
  };

  useEffect(() => {
    let refreshParams: any = {
      force: true,
      suppressFlash: true,
    };
    gridRef?.current!.api?.refreshCells(refreshParams);
  }, [globalSearch]);

  const onDoesfilter = useCallback((node: any) => {
    doesExternalFilterPass(node);
    return true;
  }, []);

  const onCellClicked = (params: any) => {
    if (params?.colDef?.field === "lender_ref_id") {
    } else {
      if (params?.data?.ticker) {
        const id = params?.data?.recallId
          ? params?.data?.recallId
          : params?.data?.contract_id;
        setCurrentRowId(id);
        onRowSelected(params?.data?.ticker, params?.data?.id);
        const refreshParams: any = {
          force: true,
          suppressFlash: true,
        };
        setTimeout(() => {
          gridRef?.current!.api?.redrawRows(refreshParams);
        }, 50);
      }
    }
  };

  // const isRowSelectable = useMemo(() => {
  //   return (rowNode: any) => {
  //     return (
  //       rowNode?.data?.loan_qty !== rowNode?.data?.quantity &&
  //       !rowNode?.data?.isFullyRecalled &&
  //       rowNode?.data?.loanet_status !== "Pending"
  //     );
  //   };
  // }, []);


  
const isRowSelectable = useMemo(() => {
  return (rowNode: any) => {
    const data = rowNode?.data;

    if (data?.isFullyRecalled) {
      return false;
    }

    if (data?.loanet_status === "Pending") {
      return false;
    }

    // if (data?.isRecall === "N" && data?.loanet_status === "Rejected") {
    //   return false;
    // }

    return true;
  };
}, []);




  const getRowStyle: any = (params: any) => {
    if (
      ((params.node.data?.recallId > 0 &&
        params.node.data?.recallId === currentRowId) ||
        (params.node.data?.contract_id &&
          params.node.data?.contract_id === currentRowId)) &&
      params.node.rowPinned !== "bottom"
    ) {
      params.node.suppressRowHoverHighlight = true;
      return { background: "#bbdffc" };
    } else if (
      params.node.rowIndex % 2 === 0 &&
      params.node.rowPinned !== "bottom"
    ) {
      return { background: "#F8F8F8" };
    }
    if (params.node.rowPinned === "bottom") {
      return {
        backgroundColor: "#fff !importnat",
        color: "#164691",
        fontWeight: "700",
        fontSize: "0.75rem",
        fontStyle: "normal",
        borderBottom: "none",
        border: "none",
      };
    } else {
      return { backgroundColor: "#fff" };
    }
  };

  return (
    <>
      <div className="d-flex flex-row justify-content-between">
        <div className="justify-content-start">
          {title !== undefined && (
            <div
              style={{
                height: "1rem",
                paddingLeft: "0.4rem",
                paddingTop: "0.8rem",
                paddingBottom: "0.8rem",
              }}
              className="drag-handle title-subHeaderTitle"
            >
              {title}
            </div>
          )}
        </div>
        <div
          className="d-flex flex-row justify-content-between me-2"
          style={{
            height: "1.2rem",
            paddingTop: "0.8rem",
            paddingBottom: "0.8rem",
          }}
        >
          <div className="form-check form-switch d-flex align-self-center">
            <input
              checked={isFullRecallFilterActive}
              onChange={() =>
                setIsFullRecallFilterActive(!isFullRecallFilterActive)
              }
              className="form-check-input me-2"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
            />
            <label
              className="form-check-label text-nowrap mb-0 align-self-center"
              style={{ fontSize: "small" }}
              htmlFor="flexSwitchCheckDefault"
            >
              Exclude Full Recall
            </label>
          </div>
        </div>
      </div>
      <div
        className="w-100 row p-0 d-flex align-items-center"
        style={{ height: "3%", marginBottom: 2 }}
      >
        <div className="float-start ps-2 col-10 d-flex align-items-center h-100">
          <div className="d-flex h-100 align-items-center flex-row">
            <div className="ms-2 d-flex align-items-center h-100 metrics-div">
              <button
                type="button"
                onClick={() => {
                  onOpenFilter();
                }}
                className={`metrics-btn p-1 d-flex h-75 align-items-center btn btn-settled ${
                  isOpenFilterActive ? "btn btn-filter-active" : ""
                }`}
              >
                Open ({openCount})
              </button>
            </div>
            <div className="ms-2 d-flex align-items-center h-100 metrics-div">
              <button
                type="button"
                onClick={() => {
                  onNonOutstandingFilter();
                }}
                className={`metrics-btn p-1 d-flex h-75 align-items-center btn btn-settled ${
                  isNonOutstandingFilterActive ? "btn btn-filter-active" : ""
                }`}
              >
                Today’s ({nonOutstandingCount})
              </button>
            </div>
            <div className="ms-2 d-flex align-items-center h-100 metrics-div">
              <button
                type="button"
                onClick={() => {
                  onPastDueFilter(true);
                }}
                className={`metrics-btn p-1 d-flex align-items-center h-75 btn btn-unsettled ${
                  isPastDueFilterActive ? "btn btn-filter-active" : ""
                }`}
              >
                Past-Due ({pastDueCount})
              </button>
            </div>
            <div className="ms-2 d-flex align-items-center h-100 metrics-div">
              <button
                type="button"
                onClick={() => {
                  onPastDueFilter();
                }}
                className={`metrics-btn p-1 d-flex align-items-center h-75 btn btn-unsettled ${
                  isPast30dayDueFilterActive ? "btn btn-filter-active" : ""
                }`}
              >
                Past 30 days Due ({past30dayDueCount})
              </button>
            </div>
            <div className="ms-2 d-flex align-items-center h-100 metrics-div">
              <button
                type="button"
                onClick={() => {
                  onPartialReturnFilter(true);
                }}
                className={`metrics-btn p-1 d-flex align-items-center h-75 btn btn-unallocated ${
                  isPartialReturnFilterActive ? "btn btn-filter-active" : ""
                }`}
              >
                Partial Return ({partialReturnCount})
              </button>
            </div>
            <div className="ms-2 d-flex align-items-center h-100 metrics-div">
              <button
                type="button"
                onClick={() => {
                  onPartialReturnFilter();
                }}
                className={`metrics-btn p-1 d-flex align-items-center h-75 btn btn-unallocated ${
                  isFullReturnFilterActive ? "btn btn-filter-active" : ""
                }`}
              >
                Full Return ({fullReturnCount})
              </button>
            </div>
            <div className="ms-2 h-100 d-flex align-items-center metrics-div">
              <button
                type="button"
                onClick={() => {
                  onRecallFilter(true);
                }}
                className={`metrics-btn p-1 h-75 d-flex align-items-center btn btn-allocated ${
                  isRecallFilterActive ? "btn btn-filter-active" : ""
                }`}
              >
                IsRecall ({recallCount})
              </button>
            </div>
          </div>
        </div>

        <div className="col-2 p-0 h-100 d-flex justify-content-end">
          <button
            type="button"
            disabled={
              selectedGridRows?.length === 0 ||
              !hasAccess([
                `${pageConstant?.RECALLS}_ADMIN`,
                `${pageConstant?.RECALLS}_RW`,
              ])
            }
            className="btn btn-primary d-flex align-self-center justify-content-center add-recall-btn"
            onClick={onRecall}
          >
            Recall
          </button>
        </div>
      </div>
      <div className="ag-theme-balham" style={{ height: "88%" }}>
        <AgGridReact
          ref={gridRef}
          rowStyle={{
            justifyContent: "center",
            color: "#2D2D2D",
            fontSize: "0.75rem",
            fontWeight: "400",
            fontStyle: "normal",
          }}
          rowHeight={22}
          columnDefs={columnDefs}
          getRowId={getRowId}
          onFirstDataRendered={onFirstDataRendered}
          onRowDataUpdated={onGridRowDataChanged}
          rowData={rowData}
          rowSelection={"multiple"}
          onSelectionChanged={onSelectionChanged}
          onCellClicked={onCellClicked}
          defaultColDef={defaultColDef}
          suppressAggFuncInHeader={true}
          enableCellChangeFlash={true}
          enableRangeSelection={true}
          onGridReady={onGridReady}
          onFilterModified={onFilterModified}
          onFilterChanged={onFilterChanged}
          onGridSizeChanged={onGridSizeChanged}
          onColumnResized={onColumnResized}
          rowClassRules={rowClassRules}
          getRowStyle={getRowStyle}
          onCellValueChanged={onCellValueChanged}
          autoGroupColumnDef={autoGroupColumnDef}
          groupSelectsChildren={true}
          groupSelectsFiltered={true}
          sideBar={sideBar}
          pivotMode={false}
          cacheQuickFilter={false}
          isExternalFilterPresent={isExternalFilterPresent}
          doesExternalFilterPass={onDoesfilter}
          getContextMenuItems={getContextMenuItems}
          quickFilterText={globalSearch}
          overlayLoadingTemplate={
            '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
          }
          onRowSelected={onGridRowSelected}
          isRowSelectable={isRowSelectable}
          suppressRowClickSelection={true}
          suppressRowHoverHighlight={true}
        ></AgGridReact>
      </div>
    </>
  );
};

function CustomTooltip() {}

CustomTooltip.prototype.init = function (params: any) {
  var type = params.type || "primary";
  var data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;
  var eGui = (this.eGui = document.createElement("div"));

  eGui.classList.add("custom-tooltip");
  this.eGui.innerHTML =
    '<div class="panel panel-' +
    type +
    '">' +
    '<div class="panel-heading">' +
    '<h3 class="panel-title">' +
    data.country +
    "</h3>" +
    "</div>" +
    '<div class="panel-body">' +
    '<h4 style="white-space: nowrap;">' +
    data.athlete +
    "</h4>" +
    "<p>Total: " +
    data.total +
    "</p>" +
    "</div>" +
    "</div>";
};

CustomTooltip.prototype.getGui = function () {
  return this.eGui;
};

export default LoanRecallsGrid;
